export const formatDate = (dateString: string): string => {
  const date = new Date(Date.parse(dateString))
  const day = date.getUTCDate()
  const monthIndex = date.getUTCMonth() + 1
  const year = date.getUTCFullYear()

  return day + '.' + monthIndex + '.' + year
}

export const formatDateDaysLeft = (dateString: string): string => {
  const date = new Date(Date.parse(dateString))
  const today = new Date()
  const oneDay = 1000 * 60 * 60 * 24
  const daysleft = Math.ceil((date.getTime() - today.getTime()) / oneDay)
  return daysleft.toString()
}
